import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import DashboardHeader from './components/HeaderACV';
import RicambiContent from './components/RicambiContent';
import OrizonFooter from './components/OrizonFooter';
import Icon from '../../components/AppIcon';
import NewInsertCCO from './components/NewInsertCCO';

// Jednostavna Toast komponenta za prikaz greške
const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 4000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div className="fixed top-8 left-1/2 -translate-x-1/2 z-[300] px-6 py-3.5 rounded-2xl shadow-2xl flex items-center gap-3 animate-in slide-in-from-top-4 duration-300 bg-red-500 text-white">
      <Icon name="AlertCircle" size={20} />
      <span className="text-sm font-black uppercase tracking-wider whitespace-nowrap">{message}</span>
    </div>
  );
};

const RicambiPage = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  // ─── Funkcija za proveru autorizacije ───
  const handleOpenModal = async () => {
    setIsChecking(true);
    try {
      const { data: { user }, error: authError } = await supabase.auth.getUser();
      
      if (authError || !user) {
        setErrorMsg("Devi effettuare il login!");
        return;
      }

      // Provera u tabeli 'profili'
      const { data: profil, error: dbError } = await supabase
        .from('profili')
        .select('nome, ruolo')
        .eq('id', user.id)
        .single();

      if (dbError || !profil) {
        setErrorMsg("Errore nel recupero profilo!");
        return;
      }

      // Provera uloge (ruolo)
      if (profil.ruolo === 'cco-admin' || profil.ruolo === 'Owner') {
        setIsModalOpen(true);
      } else {
        setErrorMsg(`Spiacente ${profil.nome || ''}, non sei autorizzato!`);
      }
    } catch (err) {
      setErrorMsg("Errore imprevisto!");
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <DashboardHeader />
      
      {/* Prikaz greške ako postoji */}
      {errorMsg && <Toast message={errorMsg} onClose={() => setErrorMsg(null)} />}

      <main className="flex-grow w-full relative">
        <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12 pt-24 md:pt-32 pb-12">
          
          <div className="flex items-center justify-between mb-8">
            <button 
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-muted/50 hover:bg-muted border border-border/50 transition-all group shadow-sm"
            >
              <Icon name="ArrowLeft" size={18} className="group-hover:-translate-x-1 transition-transform" />
              <span className="text-[10px] font-black uppercase tracking-widest">Indietro</span>
            </button>

            {/* Dugme sa proverom */}
            <button 
              onClick={handleOpenModal}
              disabled={isChecking}
              className="flex items-center gap-2 px-4 py-2 md:px-6 md:py-3 rounded-2xl bg-primary text-white hover:bg-primary/90 transition-all shadow-lg shadow-primary/20 group active:scale-95 disabled:opacity-50"
            >
              {isChecking ? (
                <Icon name="Loader2" size={20} className="animate-spin" />
              ) : (
                <Icon name="Plus" size={20} className="group-hover:rotate-90 transition-transform duration-300" />
              )}
              <span className="hidden md:inline text-[10px] font-black uppercase tracking-[.2em]">
                {isChecking ? 'Verifica...' : 'Nuovo Articolo'}
              </span>
            </button>
          </div>

          <RicambiContent />
        </div>
      </main>

      <NewInsertCCO 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onRefresh={() => {
          console.log("Podaci uspešno uneti, osvežavam listu...");
          // Ovde možeš dodati logiku za refresh bez reloada, npr. setRefreshKey(k => k + 1)
        }}
      />

      <OrizonFooter />
    </div>
  );
};

export default RicambiPage;